export default __webpack_public_path__ + "static/media/google.849eda0f.svg";